module.exports = __webpack_public_path__ + "img/pes-logo.73610a64.svg";